// Aturan nomor telepon — SAMA dengan backend/telepon.py.
export const PESAN_TELEPON = "Nomor telepon tidak sah";

export const digitsOnly = (v) => String(v || "").replace(/\D/g, "");

// Angka sesudah 62: buang non-angka, lalu awalan "62", lalu awalan "0".
export const sisaTelepon = (v) => {
  let d = digitsOnly(v);
  if (d.startsWith("62")) d = d.slice(2);
  if (d.startsWith("0")) d = d.slice(1);
  return d;
};

export const teleponValid = (v) => /^8\d{8,11}$/.test(sisaTelepon(v));

// Format simpan: "62" + sisa; "" bila tidak sah.
export const teleponSimpan = (v) => (teleponValid(v) ? `62${sisaTelepon(v)}` : "");

export const kelompokTelepon = (d) => [d.slice(0, 3), d.slice(3, 7), d.slice(7)].filter(Boolean).join("-");

// Format tampil "(+62) 812-3456-7890"; nomor lama yang tidak sah ditampilkan apa adanya.
export const formatTelepon = (v) => {
  if (!String(v || "").trim()) return "";
  return teleponValid(v) ? `(+62) ${kelompokTelepon(sisaTelepon(v))}` : String(v);
};

// Isi kolom (tanpa awalan tetap "(+62)").
export const isianTelepon = (v) => kelompokTelepon(sisaTelepon(v));
